import React from 'react';

const ForbiddenPage = () => {
  return <div>You are not allowed to see this page.</div>;
};

export default ForbiddenPage;
